import * as types from '../actions/types';
import initialState from './initialState';
import reject from 'lodash/reject'

export default function waitlistReducer(state = initialState.waitlist, action) {
  switch (action.type) {
    case types.GET_WAITLIST_START:
      return {
        ...state,
        isOnFetch: true
      }
    case types.GET_WAITLIST_SUCCESS:
      return {
        isOnFetch: false,
        isFetched: true,
        data: action.payload
      }
    case types.DELETE_WAITLIST_SUCCESS:
      return {
        ...state,
        data: reject(state.data, item => item.id === action.payload)
      }
    case types.ADD_WAITLIST_SUCCESS:
      return {
        ...state,
        data: state.data.concat(action.payload)
      }
    case types.UPDATE_WAITLIST:
      return {
        ...state,
        data: state.data.map(item => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              ...action.payload.data
            }
          } else {
            return item
          }
        })
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/waitlistReducer.js